(ns ui.accordion
  (:require ["@radix-ui/react-accordion" :as RadixAccordion]
            [lucide-react :refer [ChevronDown]]
            [ui.utils :refer [clsx separate-props]]))

(defn accordion-item [& args]
  (let [[props children] (separate-props args)]
    (into [:> RadixAccordion/Item (-> props
                                      (dissoc :active)
                                      (update :class #(clsx "border-b"
                                                            %)))]
          children)))

(defn accordion-trigger [& args]
  (let [[props children] (separate-props args)]
    [:> RadixAccordion/Trigger (-> (merge {:asChild true} props)
                                   (dissoc :reversed :icon-right)
                                   (update :class #(clsx "flex flex-1 items-center justify-between py-2 font-medium transition-all cursor-pointer radix-state-open:[&_svg]:rotate-180 data-disabled:cursor-default data-disabled:opacity-50 data-disabled:pointer-events-none"
                                                         %)))
     [:div {:class (clsx "flex justify-between items-center w-full gap-2"
                         {"flex-row-reverse" (:reversed props)})}
      (into [:div {:class "flex-1"}] children)
      [:> ChevronDown {:class "transition-transform"}]]]))

(defn accordion-content [& args]
  (let [[props children] (separate-props args)]
    (into [:> RadixAccordion/Content (-> props
                                         (update :class #(clsx "overflow-hidden transition-all h-0 radix-state-open:h-[var(--radix-collapsible-content-height)]"
                                                               %)))]
          children)))

(defn accordion-root [& args]
  (let [[props children] (separate-props args)]
    (into [:> RadixAccordion/Root props]
          children)))
